import React from 'react'

const Loader = () => {
  return (
    <div className='loaderSection'>
      <div className="preloader" id="preloader"></div>
    </div>
  )
}

export default Loader
